import StatementsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/StatementsPage";
import { BCMSStateManagerCRUD, useBCMSContext, BCMSRecord } from "bcms-react";
import Classes from "model";

export default function CaptureEStatementsExpandedSearch(prop) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "searchAccordion", "isActive" ], true)
        .update([ "advancedSearch", "isActive" ], true)
        .submit();

    return <StatementsPage ui={ ui } />
}